
<app-radio-input-group #childDiagnosisComponent [indication]="indication" [labelName]="'Diagnosis'" [controlName]="'diagnosis'" 
[controlDisplayName]="'Diagnosis'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedControlSelectionChangedHandler($event)"></app-radio-input-group>
<div class="criteria-section" *ngIf="showCriteriaSection()">
  <br />
  <kendo-label
  [text]="'Definition of Hypertension'"
  class="input-label-header"
  ></kendo-label>
  <hr class="input-label-header-hr" />
</div>
<form [formGroup]="formGroup" [hidden]="!showCriteriaSection()">
  <div class="row">
    <kendo-label class="k-form" [text]="hypertensionInputOptions[1][0].displayName" style="color: #92929f;">
      <kendo-textbox
        [style.width.px]="200"
        [formControlName]="hypertensionInputOptions[1][0].name"
        placeholder=""
        [clearButton]="true"
        (valueChange)="updateSelections()"
        [maxlength]="3"
        [minlength]="1"
      >
      </kendo-textbox>
    </kendo-label>
  </div>
  <div class="row">
    <div class="form-check condition-radios" *ngFor="let inputOption of hypertensionInputOptions[0]">
        <kendo-label
          class="form-check-label"
          [for]="radioOption"
          [text]="inputOption.displayName"
        ></kendo-label>
        <input
          class="form-check-input"
          type="radio"
          name="condition"
          #radioOption
          [value]="inputOption.name"
          formControlName="condition"
          kendoRadioButton
          (change)="updateSelections()"
        />
    </div>
  </div>
  <div class="row">
    <kendo-label class="k-form" [text]="hypertensionInputOptions[1][1].displayName" style="color: #92929f;">
      <kendo-textbox
        [style.width.px]="200"
        [formControlName]="hypertensionInputOptions[1][1].name"
        placeholder=""
        [clearButton]="true"
        (valueChange)="updateSelections()"
        [maxlength]="3"
        [minlength]="1"
      >
      </kendo-textbox>
    </kendo-label>
  </div>
</form>
<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>
